import { render } from "./PraktischeAfspraken.vue?vue&type=template&id=f237faf2&scoped=true"
import script from "./PraktischeAfspraken.vue?vue&type=script&lang=js"
export * from "./PraktischeAfspraken.vue?vue&type=script&lang=js"

import "./PraktischeAfspraken.vue?vue&type=style&index=0&id=f237faf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f237faf2"]])

export default __exports__